export default "data:image/svg+xml,european_union.svg"